import MEATheme from './mea.theme';

export default MEATheme;
